import React from "react";
import { TradeDrawerListItemSection } from "../styles";
import { useInfo24H } from "@app/hooks/trade/info24H";
import ListCoin from "./ListCoin";
import PriceHigh from "./PriceHigh";
import ListVolume from "./ListVolume";
import { useIndexPrice } from "@app/hooks/trade/indexprice";
import { goTo } from "@app/hooks/navigation";
import { useNavigate } from "react-router-dom";

const HeaderSearchItem = ({ item, index }: any) => {
  const navigation = useNavigate();
  //const { data: info24H } = useInfo24H(item?.id);

  const { getInfo24H } = useInfo24H();
  const info24H = getInfo24H(item?.id);

  const { getPrice } = useIndexPrice(item?.id);

  return (
    <TradeDrawerListItemSection
      onClick={() => {
        // goTo(navigation, `/trade/${item?.id}`);
        location.href = `/trade/${item?.id}`;
      }}
    >
      <ListCoin item={item} />
      <PriceHigh indexPrice={getPrice(item?.id)} info24H={info24H} />
      <ListVolume volume={info24H?.volume} />
    </TradeDrawerListItemSection>
  );
};

export default HeaderSearchItem;
